import { commitMutation, graphql } from 'react-relay';
import { UUIDUtil } from '@aperza/util';

const mutation = graphql`
  mutation SaveClipMutation($input: SaveClipInput!) {
    saveClip(input: $input) {
        data
    }
  }
`;

function commit(environment, args, onCompleted) {
  let clientMutationId = UUIDUtil.uuid();
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        ...args,
        clientMutationId: clientMutationId,
      }
    },
    updater: store => {
    },
    onCompleted: onCompleted,
    optimisticUpdater: store => {
    }
  });
}

export default { commit };
